import React, { useState } from 'react';
import '../App.css';

const WelcomeBackModal = ({ 
  isOpen, 
  onClose, 
  prayerData,
  userStats = {},
  currentPreferences = {}
}) => {
  const [showPreferences, setShowPreferences] = useState(false);
  const [notifyOnPrayer, setNotifyOnPrayer] = useState(currentPreferences.notify_on_prayer || false);
  const [weeklySummary, setWeeklySummary] = useState(currentPreferences.weekly_summary || false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateSuccess, setUpdateSuccess] = useState(false);

  if (!isOpen) return null;

  const handleUpdatePreferences = async () => {
    setIsUpdating(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      
      const response = await fetch(`${API_URL}/api/subscriptions/update-preferences`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: prayerData.email,
          notifyOnPrayer,
          weeklySummary,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setUpdateSuccess(true);
        setTimeout(() => {
          onClose(true);
        }, 1500);
      } else {
        alert('Error al actualizar preferencias. Inténtalo de nuevo.');
      }
    } catch (err) {
      console.error('Error:', err);
      alert('Error al conectar con el servidor');
    } finally {
      setIsUpdating(false);
    }
  };

  const handleClose = () => {
    onClose(true);
  };

  return (
    <div className="subscription-modal-overlay" onClick={handleClose}>
      <div className="subscription-modal" onClick={(e) => e.stopPropagation()}>
        {updateSuccess ? (
          <div className="subscription-success">
            <div className="success-icon">✅</div>
            <h2>¡Preferencias actualizadas!</h2>
            <p>Tus cambios han sido guardados correctamente.</p>
          </div>
        ) : (
          <>
            <button className="modal-close" onClick={handleClose}>×</button>
            
            <div className="modal-header">
              <div className="modal-icon">🙏</div>
              <h2>¡Bienvenido de nuevo, {prayerData.nombre}!</h2>
            </div>

            <div className="modal-content">
              <div className="welcome-back-message">
                <p className="gratitude-message">
                  ✨ <strong>¡Gracias por seguir confiando en nuestra comunidad de oración!</strong>
                </p>
                
                <p className="user-stats-message">
                  Has enviado <strong>{userStats.previousPrayers + 1}</strong> {userStats.previousPrayers + 1 === 1 ? 'pedido' : 'pedidos'} de oración.
                  {userStats.totalPrayersReceived > 0 && (
                    <> La comunidad ha orado <strong>{userStats.totalPrayersReceived}</strong> {userStats.totalPrayersReceived === 1 ? 'vez' : 'veces'} por tus intenciones. ❤️</>
                  )}
                </p>

                <div className="encouragement-box">
                  <p className="encourage-text">
                    💙 <strong>¿Sabías que tu oración también cuenta?</strong>
                  </p>
                  <p>
                    Cuando ores por las intenciones de otros, les llegarás al corazón y les darás esperanza. 
                    ¡Visita el inicio para ver los pedidos de la comunidad!
                  </p>
                </div>

                <div className="current-subscription-info">
                  <p className="subscription-status">
                    ✅ <strong>Tu suscripción está activa</strong>
                  </p>
                  <p className="preferences-summary">
                    {currentPreferences.notify_on_prayer && '📧 Recibes avisos cuando alguien ora por ti'}
                    {currentPreferences.notify_on_prayer && currentPreferences.weekly_summary && ' • '}
                    {currentPreferences.weekly_summary && '📬 Recibes resumen semanal los domingos'}
                  </p>
                </div>

                {!showPreferences ? (
                  <div className="modal-actions">
                    <button
                      className="btn-subscribe"
                      onClick={handleClose}
                    >
                      Gracias, entendido
                    </button>
                    <button
                      className="btn-preferences-link"
                      onClick={() => setShowPreferences(true)}
                    >
                      Cambiar mis preferencias
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="preferences-editor">
                      <h3>Actualizar preferencias de notificación</h3>
                      
                      <div className="subscription-options">
                        <label className="option-item">
                          <input
                            type="checkbox"
                            checked={notifyOnPrayer}
                            onChange={(e) => setNotifyOnPrayer(e.target.checked)}
                          />
                          <div className="option-content">
                            <strong>Avísame cuando alguien ore por mi intención</strong>
                            <span className="option-description">
                              Recibirás un resumen diario de quiénes oraron por ti
                            </span>
                          </div>
                        </label>

                        <label className="option-item">
                          <input
                            type="checkbox"
                            checked={weeklySummary}
                            onChange={(e) => setWeeklySummary(e.target.checked)}
                          />
                          <div className="option-content">
                            <strong>Resumen semanal</strong>
                            <span className="option-description">
                              Nuevos pedidos de la comunidad + reflexiones espirituales
                            </span>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div className="modal-actions">
                      <button
                        className="btn-subscribe"
                        onClick={handleUpdatePreferences}
                        disabled={isUpdating || (!notifyOnPrayer && !weeklySummary)}
                      >
                        {isUpdating ? 'Guardando...' : 'Guardar cambios'}
                      </button>
                      <button
                        className="btn-skip"
                        onClick={() => setShowPreferences(false)}
                        disabled={isUpdating}
                      >
                        Cancelar
                      </button>
                    </div>
                  </>
                )}

                <p className="unsubscribe-note">
                  💡 En cada email que recibas encontrarás opciones para desuscribirte de un pedido específico o de todas las notificaciones
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WelcomeBackModal;

